import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthProvider";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F1E8]">
        <div className="text-sm text-[#6C757D]" data-testid="auth-checking">Checking your session…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (adminOnly && user.role !== "admin" && user.role !== "super_admin") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F1E8] p-6">
        <div className="card-soft p-8 max-w-md text-center" data-testid="forbidden">
          <div className="text-[#E76F51] font-display font-bold text-xl">Admin only</div>
          <p className="text-sm text-[#6C757D] mt-2">This area is restricted to administrators. Your role is <span className="font-semibold text-[#222]">{user.role}</span>.</p>
        </div>
      </div>
    );
  }
  return children;
}
